<template>
    <div class="login-form">
        <h1>כניסת סוכנים</h1>
        <form @submit.prevent="login">
            <div class="form-group">
                <label for="phone">טלפון</label>
                <input class="pm-input" type="tel" id="phone" v-model="credentials.phone" autocomplete="phone" required>
            </div>
            <button type="submit">קבל קוד ב SMS</button>
        </form>
				<p v-if="userNotFound" class="msg">משתמש לא נמצא</p>
    </div>
</template>

<script>

export default {
    name: "Login",
    data(){
        return {
            credentials: {
                phone: ''
            },
						userNotFound: false
        }
    },
    methods: {
        async login(){
            if(await this.$store.dispatch('otp', this.credentials)){
                await this.$router.push({name: 'otp-confirmation'})
            }else{
								this.userNotFound = true;
								setTimeout(() => {
									this.userNotFound = false;
								}, 2000);
            }
        }
    }
}
</script>

<style lang="scss">
.login-form {
    text-align: center;
    color: #fff;

		.msg {
			margin: 15px 0;
			color: var(--btn-bg);
			background-color: var(--btn-text);
			padding: 10px 5px;
			border-radius: 4px;
		}

    h1 {
        font-size: 2.4rem;
        font-weight: 500;
    }

    label {
        display: block;
        color: #fff;
        margin-bottom: 10px;
        font-size: 1.5rem;
    }
    button {
        background-image: none;
        background-color: #BD2E39;
        border-radius: 5px;
        border: none;
        color: #fff;
        font-size: 1.125rem;
        min-width: 230px;
        padding: 5px;
        cursor: pointer;
    }

    .form-group {
        margin-bottom: 15px;
    }

    .pm-input {
        background: #FFFFFF;
        border: 1px solid #E7E7E7;
        box-sizing: border-box;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 24px 0 24px 24px;
        height: 45px;
        color: #2E3172;
        min-width: 111px;
        font-size: 1.125rem;
        padding: 5px;

        &:not(select){
            padding: 4px;
            font-size: 1.25rem;
            font-weight: 700;
            text-align: center;
        }
    }
}
</style>
